module.exports = __webpack_public_path__ + "assets/img/bg-donate.073c9bb9ec96abae21b806cce043ae50.svg";